import axios from 'axios';
import { BASE_URL } from "../Screens/Settings/DASHBOARD_SETTINGS";

const fetchTests = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/api/services/getRequests`);
    return response.data;
  } catch (error) {
    console.error('Error fetching items:', error.message);
    throw error;
  }
};

export default fetchTests;
